define((require) => {
    "use strict";

    var SalesforceCommerceAbstractDataAdapter = require("../SalesforceCommerceAbstractDataAdapter"),
        {trim}                        = require("shared/util/StringUtils");

    /**
     * @class {SalesforceCommerceDataAdapter}
     *
     * A <i>SalesforceCommerceDataAdapter</i> proves the mapping between the external and internal formats.
     *
     * @author Pedro Augusto / <a href="http://www.zmags.com">Zmags</a>
     *
     */
    var SalesforceCommerceDataAdapter =  SalesforceCommerceAbstractDataAdapter.extend({

        /**
         *  Maps a product from OCAPI into a <tt>SalesforceCommerceProductModel</tt>.
         *  @override
         *  @example
         *  <pre>{
         *       "brand" : "Creative",
         *       "id" : "creative-zen-v",
         *       "image_groups" : [
         *         {
         *           "images" : [ {
         *             "alt" : "Creative ZEN V Digital Media Player, , small",
         *             "link" : "http://localhost/on/salesforcecommerce.static/Sites-SiteGe..",
         *             "title" : "Creative ZEN V Digital Media Player, "
         *           } ],
         *           "view_type" : "small"
         *         } ],
         *       "name" : "Creative ZEN V Digital Media Player",
         *       "page_description" : "The ZEN V player was designed for people ...",
         *       "page_keywords" : "Creative",
         *       "page_title" : "Creative ZEN V Digital Media Player",
         *       "primary_category_id" : "electronics-digital-media-players",
         *       "short_description" : "The ZEN V player was designed for people...",
         *       "type" : {
         *         "item" : true
         *       },
         *       ...
         *       "c_mediaFormat" : [ "0010", "0020", "0030", "0040" ],
         *       "c_memorySize" : "1GB",
         *       "c_tabDescription" : "The ZEN V player was designed for people ..."
         *   }
         *   </pre>
         *   @return {Object} return the Map for the OCAPI.
         */
        getMaps: function() {
            return {
                name: {value: "name"},

                productID: {value: "id"},

                brand: {defaultValue: "(none)", value: "brand"},

                availability: {defaultValue: "(none)", value: "orderable"},

                price: {
                    value: function() {
                        return this.currency + " " + this.price;
                    }
                },

                image: {
                    value: this._getProductImage
                },

                description: {
                    defaultValue: "No description",
                    value: "short_description"
                }
            };
        },

        /**
         * Filter the target object according with the settings values. If the corresponding parameter is setted to
         * false the property value will setted to null.
         *
         * @override
         * @param {Object} target already tranformed.
         * @param {Object} settings informed by the user.
         */
        filter: function(target, settings) {
            var filters = settings.get("filters"),
                key;

            for (key in target) {
                if (filters.get(key) === false) {
                    target[key] = null;
                }
            }
        },

        /**
         * Try to find a image inside of the OCAPI Product object.
         *
         * @example
         * <pre>
         * {...
         *
         * "image_groups" : [
         *    {
         *        {
         *         "images" : [ {
         *            "alt" : "Creative ZEN V Digital Media Player, , small",
         *            "link" : "http://localhost/on/salesforcecommerce.static/Sites-SiteG....jpg",
         *            "title" : "Creative ZEN V Digital Media Player, "
         *          } ],
         *          "view_type" : "small"
         *        } ]
         *     }
         *     ...
         *
         * }
         * </pre>
         * @param {Object} product object
         * @return {String} The image address; never null/undefined, but will be empty if no image.
         * @private
         */
        _getProductImage: function() {
            var imageAddress = null;

            if (this.image_groups &&
                this.image_groups.length > 0 &&
                this.image_groups[0].images &&
                this.image_groups[0].images.length > 0) {
                imageAddress = this.image_groups[0].images[0].link;
            }

            // Trim surrounding whitespace...
            return trim(imageAddress || "");
        }

    });

    return new SalesforceCommerceDataAdapter();
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/service/v15/SalesforceCommerceDataAdapter.js